import { render } from "./MarketingServices.vue?vue&type=template&id=20b0610a&scoped=true"
import script from "./MarketingServices.vue?vue&type=script&lang=js"
export * from "./MarketingServices.vue?vue&type=script&lang=js"

import "./MarketingServices.vue?vue&type=style&index=0&id=20b0610a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b0610a"]])

export default __exports__